import { render, staticRenderFns } from "./LaboratoriumHistory.vue?vue&type=template&id=35ffa909"
import script from "./LaboratoriumHistory.vue?vue&type=script&lang=js"
export * from "./LaboratoriumHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports